module.exports = __webpack_public_path__ + "statics/img/hui.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/common/hui.png
// module id = QofJ
// module chunks = 1